/**
 * Analitik entalpiya integrallari ∫ Cp dT — dinamik modelda har bo'lak uchun
 * har qadamda chaqiriladi, shuning uchun sonli integral o'rniga yopiq shakl.
 */
import type { PolyProp, ShomateProp } from './types';

/** ∫_{T1}^{T2} poly(T) dT, poly o'zgaruvchisi K yoki °C bo'lishi mumkin (dT = dx) */
export function integratePoly(p: PolyProp, T1: number, T2: number): number {
  const shift = p.variable === 'C' ? 273.15 : 0;
  const x1 = T1 - shift;
  const x2 = T2 - shift;
  let sum = 0;
  let p1 = x1;
  let p2 = x2;
  for (let i = 0; i < p.coeffs.length; i++) {
    sum += ((p.coeffs[i] as number) * (p2 - p1)) / (i + 1);
    p1 *= x1;
    p2 *= x2;
  }
  return sum;
}

/**
 * ∫_{T1}^{T2} Cp_shomate dT, J/kg.
 * Cp = (A + B·t + C·t² + D·t³ + E/t²)/M,  t = T/1000,  dT = 1000·dt
 */
export function integrateShomate(
  p: ShomateProp,
  T1: number,
  T2: number,
  molarMass: number,
): number {
  const F = (T: number): number => {
    const t = T / 1000;
    return p.A * t + (p.B * t * t) / 2 + (p.C * t ** 3) / 3 + (p.D * t ** 4) / 4 - p.E / t;
  };
  return (1000 * (F(T2) - F(T1))) / molarMass;
}
